import React from 'react';

import Collapsible from 'components/Collapsible';
import Input from 'components/Input';
import {
  ITaskProgressType,
  ITemplateReportOptions,
} from 'store/tasks/tasksType';
import i18n, { languageDirection } from '../../i18n';

export interface ITemplateReportProps {
  templateReportOptions: ITemplateReportOptions;
  onChangeReportTitle: (name: string, value: boolean | string) => void;
  taskProgressType: ITaskProgressType;
  onChangeProgressType: (name: string, value: string) => void;
}

class TemplateReport extends React.Component<ITemplateReportProps> {
  onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const type = e.target.type;
    let value: string | boolean =
      type === 'checkbox' ? e.target.checked : e.target.value;
    let name: string = e.target.name;
    if (type === 'checkbox') {
      name = name.split('-').pop() || ''; // removes "checked" from end of input name
      value = value ? '' : false;
      this.props.onChangeReportTitle(name, value);
    } else if (type === 'text') {
      this.props.onChangeReportTitle(name, value);
    }
  };
  handleChangeProgressType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value: string = e.target.value;
    const name: string = e.target.name;
    this.props.onChangeProgressType(name, value);
  };

  render() {
    const { templateReportOptions, taskProgressType } = this.props;
    const floatDir = languageDirection() === 'rtl' ? 'right' : 'left';
    return (
      <Collapsible
        header={i18n.t('reportsConfig', { ns: 'companyManagement' })}
      >
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <label htmlFor="main">
              {i18n.t('main', { ns: 'companyManagement' }) as string}
            </label>
            <select
              className="browser-default"
              id="main"
              name="main"
              onChange={this.handleChangeProgressType}
              value={taskProgressType.main ? taskProgressType.main : 'null'}
            >
              <option value="null">
                {i18n.t('disabled', { ns: 'companyManagement' }) as string}
              </option>
              <option value="Assignee">
                {i18n.t('assignee', { ns: 'companyManagement' }) as string}
              </option>
              <option value="Child">
                {i18n.t('child', { ns: 'companyManagement' }) as string}
              </option>
            </select>
          </div>
          <div className="col s12 m6" style={{ float: floatDir }}>
            <label htmlFor="secondary">
              {i18n.t('secondary', { ns: 'companyManagement' }) as string}
            </label>
            <select
              className="browser-default"
              id="secondary"
              name="secondary"
              onChange={this.handleChangeProgressType}
              value={
                taskProgressType.secondary ? taskProgressType.secondary : 'null'
              }
            >
              <option value="null">
                {i18n.t('disabled', { ns: 'companyManagement' }) as string}
              </option>
              <option value="Assignee">
                {i18n.t('assignee', { ns: 'companyManagement' }) as string}
              </option>
              <option value="Child">
                {i18n.t('child', { ns: 'companyManagement' }) as string}
              </option>
            </select>
          </div>
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-completedTaskCountMain"
              checked={
                typeof templateReportOptions.completedTaskCountMain === 'string'
              }
              onChange={this.onChangeInput}
              name="check-completedTaskCountMain"
              label={
                i18n.t('completedTaskCountMain', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.completedTaskCountMain === 'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.completedTaskCountMain}
                onChange={this.onChangeInput}
                id="completedTaskCountMain"
                name="completedTaskCountMain"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-inProgressTaskCountMain"
              name="check-inProgressTaskCountMain"
              checked={
                typeof templateReportOptions.inProgressTaskCountMain ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('inProgressTaskCountMain', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.inProgressTaskCountMain ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.inProgressTaskCountMain}
                onChange={this.onChangeInput}
                id="inProgressTaskCountMain"
                name="inProgressTaskCountMain"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-notStartedTaskCountMain"
              name="check-notStartedTaskCountMain"
              checked={
                typeof templateReportOptions.notStartedTaskCountMain ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('notStartedTaskCountMain', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.notStartedTaskCountMain ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.notStartedTaskCountMain}
                onChange={this.onChangeInput}
                id="notStartedTaskCountMain"
                name="notStartedTaskCountMain"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-averageProgressMain"
              name="check-averageProgressMain"
              checked={
                typeof templateReportOptions.averageProgressMain === 'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('averageProgressMain', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.averageProgressMain === 'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.averageProgressMain}
                onChange={this.onChangeInput}
                id="averageProgressMain"
                name="averageProgressMain"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-completedTaskCountSecondary"
              name="check-completedTaskCountSecondary"
              checked={
                typeof templateReportOptions.completedTaskCountSecondary ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('completedTaskCountSecondary', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.completedTaskCountSecondary ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.completedTaskCountSecondary}
                onChange={this.onChangeInput}
                id="completedTaskCountSecondary"
                name="completedTaskCountSecondary"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-inProgressTaskCountSecondary"
              name="check-inProgressTaskCountSecondary"
              checked={
                typeof templateReportOptions.inProgressTaskCountSecondary ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('inProgressTaskCountSecondary', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.inProgressTaskCountSecondary ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.inProgressTaskCountSecondary}
                onChange={this.onChangeInput}
                id="inProgressTaskCountSecondary"
                name="inProgressTaskCountSecondary"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-notStartedTaskCountSecondary"
              name="check-notStartedTaskCountSecondary"
              checked={
                typeof templateReportOptions.notStartedTaskCountSecondary ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('notStartedTaskCountSecondary', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.notStartedTaskCountSecondary ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.notStartedTaskCountSecondary}
                onChange={this.onChangeInput}
                id="notStartedTaskCountSecondary"
                name="notStartedTaskCountSecondary"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-averageProgressSecondary"
              name="check-averageProgressSecondary"
              checked={
                typeof templateReportOptions.averageProgressSecondary ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('averageProgressSecondary', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.averageProgressSecondary ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.averageProgressSecondary}
                onChange={this.onChangeInput}
                id="averageProgressSecondary"
                name="averageProgressSecondary"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-completedTaskCountVerifier"
              name="check-completedTaskCountVerifier"
              checked={
                typeof templateReportOptions.completedTaskCountVerifier ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('completedTaskCountVerifier', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.completedTaskCountVerifier ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.completedTaskCountVerifier}
                onChange={this.onChangeInput}
                id="completedTaskCountVerifier"
                name="completedTaskCountVerifier"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-rejectedTaskCountVerifier"
              name="check-rejectedTaskCountVerifier"
              checked={
                typeof templateReportOptions.rejectedTaskCountVerifier ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('rejectedTaskCountVerifier', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.rejectedTaskCountVerifier ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.rejectedTaskCountVerifier}
                onChange={this.onChangeInput}
                id="rejectedTaskCountVerifier"
                name="rejectedTaskCountVerifier"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-notStartedTaskCountVerifier"
              name="check-notStartedTaskCountVerifier"
              checked={
                typeof templateReportOptions.notStartedTaskCountVerifier ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('notStartedTaskCountVerifier', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.notStartedTaskCountVerifier ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.notStartedTaskCountVerifier}
                onChange={this.onChangeInput}
                id="notStartedTaskCountVerifier"
                name="notStartedTaskCountVerifier"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-mainProgressTitle"
              name="check-mainProgressTitle"
              checked={
                typeof templateReportOptions.mainProgressTitle === 'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('mainProgressTitle', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.mainProgressTitle === 'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.mainProgressTitle}
                onChange={this.onChangeInput}
                id="mainProgressTitle"
                name="mainProgressTitle"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-secondaryProgressTitle"
              name="check-secondaryProgressTitle"
              checked={
                typeof templateReportOptions.secondaryProgressTitle === 'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('secondaryProgressTitle', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.secondaryProgressTitle === 'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.secondaryProgressTitle}
                onChange={this.onChangeInput}
                id="secondaryProgressTitle"
                name="secondaryProgressTitle"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-verifyTitle"
              name="check-verifyTitle"
              checked={typeof templateReportOptions.verifyTitle === 'string'}
              onChange={this.onChangeInput}
              label={
                i18n.t('verifyTitle', { ns: 'companyManagement' }) as string
              }
            />
          </div>
          {typeof templateReportOptions.verifyTitle === 'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.verifyTitle}
                onChange={this.onChangeInput}
                id="verifyTitle"
                name="verifyTitle"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-completedAssignmentCount"
              name="check-completedAssignmentCount"
              checked={
                typeof templateReportOptions.completedAssignmentCount ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('completedAssignmentCount', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.completedAssignmentCount ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.completedAssignmentCount}
                onChange={this.onChangeInput}
                id="completedAssignmentCount"
                name="completedAssignmentCount"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-inProgressAssignmentCount"
              name="check-inProgressAssignmentCount"
              checked={
                typeof templateReportOptions.inProgressAssignmentCount ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('inProgressAssignmentCount', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.inProgressAssignmentCount ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.inProgressAssignmentCount}
                onChange={this.onChangeInput}
                id="inProgressAssignmentCount"
                name="inProgressAssignmentCount"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-notStartedAssignmentCount"
              name="check-notStartedAssignmentCount"
              checked={
                typeof templateReportOptions.notStartedAssignmentCount ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('notStartedAssignmentCount', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.notStartedAssignmentCount ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.notStartedAssignmentCount}
                onChange={this.onChangeInput}
                id="notStartedAssignmentCount"
                name="notStartedAssignmentCount"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
        <div className="row">
          <div className="col s12 m6" style={{ float: floatDir }}>
            <Input
              type="checkbox"
              id="check-averageAssignmentProgress"
              name="check-averageAssignmentProgress"
              checked={
                typeof templateReportOptions.averageAssignmentProgress ===
                'string'
              }
              onChange={this.onChangeInput}
              label={
                i18n.t('averageAssignmentProgress', {
                  ns: 'companyManagement',
                }) as string
              }
            />
          </div>
          {typeof templateReportOptions.averageAssignmentProgress ===
            'string' && (
            <div className="input-field col s12 m6" style={{ float: floatDir }}>
              <Input
                type="text"
                value={templateReportOptions.averageAssignmentProgress}
                onChange={this.onChangeInput}
                id="averageAssignmentProgress"
                name="averageAssignmentProgress"
                label={i18n.t('title', { ns: 'companyManagement' }) as string}
                placeholder={
                  i18n.t('title', { ns: 'companyManagement' }) as string
                }
              />
            </div>
          )}
        </div>
      </Collapsible>
    );
  }
}

export default TemplateReport;
